"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4904],{

/***/ 12341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ ArrayTextInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _aws_amplify_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49226);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8193);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5779);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11390);
/* harmony import */ var _Validations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6686);
/* harmony import */ var _components_tootilp_Tooltip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73912);
/* harmony import */ var _libs_Utility_util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52229);










/**
 * Primary UI component for text input
 */ const ArrayTextInput = (param)=>{
    let { label , placeholder , value =[] , onChange , className , hint , validations , required , border ="border" , onKeyDown , max , min , options , labelBgColour , tooltip  } = param;
    const { theme  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .Fg)();
    const errorMessage = (0,_Validations__WEBPACK_IMPORTED_MODULE_5__/* .validate */ .G)(value, validations);
    const [showTooltip, setShowTooltip] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        // Autohide tooltip if the input is not required.
        if ((tooltip === null || tooltip === void 0 ? void 0 : tooltip.toLowerCase().includes("require")) && !required) setShowTooltip(false);
    }, [
        tooltip,
        required
    ]);
    const [textInput, setTextInput] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [selectedVal, setSelectedVal] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const getOptions = ()=>{
        if (!(0,_libs_Utility_util__WEBPACK_IMPORTED_MODULE_7__/* .isBasicOptions */ .P)(options)) options = options.map((o)=>{
            return {
                id: o === null || o === void 0 ? void 0 : o.value.toString(),
                label: o === null || o === void 0 ? void 0 : o.label
            };
        });
        return options;
    };
    const input = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_aws_amplify_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Autocomplete */ .F, {
        label: label,
        value: textInput,
        required: required,
        onKeyDown: onKeyDown,
        onChange: (e)=>{
            setTextInput(e.target.value);
        },
        onSelect: (e)=>{
            setSelectedVal({
                key: e.label,
                value: e.id
            });
            setTextInput(e.label);
        },
        innerEndComponent: null,
        outerEndComponent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
            onClick: ()=>{
                if (selectedVal && value.findIndex((v)=>v.value === selectedVal.value) === -1) {
                    onChange === null || onChange === void 0 ? void 0 : onChange([
                        ...value,
                        selectedVal
                    ]);
                    setTextInput("");
                }
            },
            title: "Add",
            className: "h-[54px] ml-2",
            type: "tertiary"
        }),
        max: max,
        min: min,
        placeholder: placeholder,
        hasSearchIcon: false,
        inputStyles: {
            padding: "15.5px 16px",
            fontSize: "14px",
            color: theme.textColour
        },
        options: getOptions(),
        crossOrigin: undefined,
        onPointerEnterCapture: undefined,
        onPointerOutCapture: undefined,
        onPointerLeaveCapture: undefined
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                style: {
                    color: "initial"
                },
                className: [
                    "relative flex-col space-y-1",
                    className
                ].join(" "),
                children: [
                    label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_tootilp_Tooltip__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        show: showTooltip,
                        tooltip: tooltip,
                        className: "flex flex-col",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "transition-all text-sm pl-1 pr-1 absolute -top-3 left-2 z-10 ".concat(errorMessage ? "text-red-500" : ""),
                            style: {
                                backgroundColor: labelBgColour !== null && labelBgColour !== void 0 ? labelBgColour : theme.backgroundColour,
                                color: theme.textColour
                            },
                            children: [
                                label,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "ml-2 text-xs",
                                    children: hint
                                })
                            ]
                        })
                    }),
                    input,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        ignoreTheme: true,
                        className: "transition-all ".concat(errorMessage ? "opacity-100" : "opacity-0", " text-red-500 text-sm font-bold"),
                        children: errorMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-wrap",
                children: value.map((v, i)=>{
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "bg-white text-black rounded px-2 m-1 flex items-center space-x-1",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: v.key
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_9__/* .AiFillCloseCircle */ .LHV, {
                                className: "hover:opacity-50 cursor-pointer",
                                onClick: ()=>{
                                    return onChange === null || onChange === void 0 ? void 0 : onChange(value.filter((i)=>i !== v));
                                }
                            })
                        ]
                    }, i);
                })
            })
        ]
    });
};


/***/ }),

/***/ 94745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ ItemPicker; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51773);



const ItemPicker = (param)=>{
    let { choices , value , itemClass , onClick  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex",
        children: choices.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                className: "text-[9px] md:text-xs flex pointer items-center justify-center border border-gray-400 w-1/6 ".concat(index !== choices.length - 1 ? "lg:mr-1" : "", "  min-h-[56px] cursor-pointer !px-1 ").concat(itemClass, " ").concat(value === item.value ? "bg-forumm-blue-light-2" : "", " \n      ").concat(index === 0 ? "rounded-l-2xl" : "", " \n      ").concat(index === choices.length - 1 ? "rounded-r-2xl" : "", " \n      ").concat(index > 0 && index < choices.length - 1 ? "!rounded-[0px]" : ""),
                onClick: ()=>onClick(item.value),
                children: "".concat(value === item.value ? "✓ " : "").concat(item.title)
            }, item.title))
    });
};


/***/ }),

/***/ 30530:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

const currencies = {
    CAD: {
        symbol: "$",
        name: "Canadian Dollar"
    },
    USD: {
        symbol: "$",
        name: "US Dollar"
    },
    EUR: {
        symbol: "€",
        name: "Euro"
    },
    GBP: {
        symbol: "\xa3",
        name: "British Pound"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (currencies);


/***/ }),

/***/ 14904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DiscountLinkModal": function() { return /* binding */ DiscountLinkModal; },
/* harmony export */   "default": function() { return /* binding */ DiscountModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_base_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18860);
/* harmony import */ var _components_inputs_ArrayTextInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12341);
/* harmony import */ var _components_inputs_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11390);
/* harmony import */ var _components_inputs_DropdownInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61993);
/* harmony import */ var _components_inputs_ItemPicker__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94745);
/* harmony import */ var _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39618);
/* harmony import */ var _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68240);
/* harmony import */ var _libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25687);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5434);
/* harmony import */ var _libs_currencies__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(30530);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];













const domain = "forumm.to";
function DiscountLinkModal(param) {
    let { show , setShow , tickets  } = param;
    var ref;
    const { formData , setFormData  } = (0,_libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_9__/* .useEventEditor */ .O)();
    const [linkData, setLinkData] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)({
        ticketName: undefined,
        discountCode: undefined,
        uri: undefined
    });
    const [availableDiscounts, setAvailableDiscounts] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]);
    const [copied, setCopied] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false);
    const pageUrl = (dcu)=>{
        return "https://".concat(domain.includes("qa") || domain.includes("app") ? "" : "app.").concat(domain, "/event/").concat(formData === null || formData === void 0 ? void 0 : formData.eventId, "/register?dcu=").concat(encodeURIComponent(dcu));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        if (linkData.ticketName && (formData === null || formData === void 0 ? void 0 : formData.discounts)) {
            const payload = formData.discounts.filter((f)=>{
                var ref;
                const payload = (ref = f.tickets) === null || ref === void 0 ? void 0 : ref.map((m)=>m.toUpperCase()).includes(linkData.ticketName.toUpperCase());
                console.log({
                    f,
                    payload,
                    linkData
                });
                return payload;
            });
            console.log({
                discounts: payload
            });
            setAvailableDiscounts(payload);
        }
        if (linkData.ticketName && linkData.discountCode) {
            const payload1 = {
                name: linkData.ticketName,
                code: linkData.discountCode
            };
            const encodedUriComp = Buffer.from(JSON.stringify(payload1), "utf8").toString("base64");
            if (linkData.uri !== encodedUriComp) setLinkData((state)=>({
                    ...state,
                    uri: encodedUriComp
                }));
        }
    }, [
        linkData
    ]);
    const handleCopy = async ()=>{
        try {
            await navigator.clipboard.writeText(pageUrl(linkData.uri));
            setCopied(true);
            setTimeout(()=>setCopied(false), 2000) // hide after 2s
            ;
        } catch (err) {
            console.error("Failed to copy!", err);
        }
    };
    const availableTickets = formData === null || formData === void 0 ? void 0 : (ref = formData.availableTickets) === null || ref === void 0 ? void 0 : ref.tickets;
    var ref1, ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        show: show,
        setShow: setShow,
        title: "Discount Links",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
            className: "flex flex-col justify-between items-center py-4",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    className: "flex flex-row justify-evenly items-center w-full mb-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_DropdownInput__WEBPACK_IMPORTED_MODULE_5__/* .DropdownInput */ .f, {
                            label: "Ticket",
                            placeholder: "Select a Ticket",
                            options: availableTickets && availableTickets.length > 0 ? availableTickets.map((t)=>{
                                const isSoldOut = !!t.remaining ? parseInt(t.remaining) < 1 : true;
                                const payload = {
                                    label: isSoldOut ? "".concat(t.ticketTitle, " - SOLD OUT") : t.ticketTitle,
                                    value: t.ticketTitle.toUpperCase(),
                                    disabled: isSoldOut
                                };
                                // console.log({ payload })
                                return payload;
                            }) : [],
                            onChange: (val)=>{
                                setLinkData((state)=>{
                                    return {
                                        ...state,
                                        ticketName: val !== null && val !== void 0 ? val : state === null || state === void 0 ? void 0 : state.ticketName,
                                        discountPercentage: 0,
                                        discountCode: undefined
                                    };
                                });
                            },
                            id: "ticket-dropdown",
                            selected: (ref1 = linkData === null || linkData === void 0 ? void 0 : linkData.ticketName) !== null && ref1 !== void 0 ? ref1 : ""
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_DropdownInput__WEBPACK_IMPORTED_MODULE_5__/* .DropdownInput */ .f, {
                            label: "Discount",
                            placeholder: "Select a Discount",
                            options: availableDiscounts && availableDiscounts.length > 0 ? availableDiscounts.map((t)=>{
                                const payload = {
                                    label: t.title,
                                    value: t.code
                                };
                                console.log({
                                    payload
                                });
                                return payload;
                            }) : [],
                            onChange: (val)=>{
                                setLinkData((state)=>({
                                        ...state,
                                        discountCode: val
                                    }));
                            },
                            id: "discount-dropdown",
                            selected: (ref2 = linkData === null || linkData === void 0 ? void 0 : linkData.discountCode) !== null && ref2 !== void 0 ? ref2 : ""
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    show: !!linkData.uri,
                    className: "flex flex-row w-full items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_7__/* .TextInput */ .o, {
                            label: "Discount Link",
                            className: "w-full",
                            disabled: true,
                            value: linkData.uri ? pageUrl(linkData.uri) : ""
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            onClick: handleCopy,
                            className: "ml-3 bg-green-400 hover:bg-green-500 rounded-md p-2 cursor-pointer flex items-center justify-center transition-all duration-150",
                            title: "Copy password",
                            children: copied ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_12__/* .MdOutlineDone */ .ddU, {
                                className: "text-white text-2xl"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_12__/* .MdOutlineFileCopy */ ._qq, {
                                className: "text-white text-2xl"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function DiscountModal(param) {
    let { show , setShow , initialData , tickets  } = param;
    var ref, ref1, ref2, ref3;
    const { formData , setFormData  } = (0,_libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_9__/* .useEventEditor */ .O)();
    const [discountModalData, setDiscountModalData] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(initialData);
    const [amountTouched, setAmountTouched] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        setDiscountModalData(initialData);
        setAmountTouched(false);
    }, [
        initialData
    ]);
    var ref4;
    const amount = Number((ref4 = discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.amount) !== null && ref4 !== void 0 ? ref4 : 0);
    const selectedTicketPrices = (tickets !== null && tickets !== void 0 ? tickets : []).filter((ticket)=>{
        var ref;
        return discountModalData === null || discountModalData === void 0 ? void 0 : (ref = discountModalData.tickets) === null || ref === void 0 ? void 0 : ref.some((title)=>title.toUpperCase() === ticket.title.toUpperCase());
    }).map((ticket)=>Number(ticket.price));
    const maximumAmount = selectedTicketPrices.length > 0 ? Math.min(...selectedTicketPrices) : 0;
    var ref5;
    const amountError = (discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.type) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .DiscountType.Amount */ .Lb.Amount && amountTouched ? amount <= 0 ? "Discount amount must be greater than 0" : !/^\d+(\.\d{1,2})?$/.test(String((ref5 = discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.amount) !== null && ref5 !== void 0 ? ref5 : "")) ? "Discount amount must have at most 2 decimal places" : selectedTicketPrices.length > 0 && amount > maximumAmount ? "Discount amount cannot exceed the cheapest selected ticket (".concat(maximumAmount.toFixed(2), ")") : undefined : undefined;
    var ref6;
    const currencyCode = (ref6 = formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : (ref1 = ref.currency) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase()) !== null && ref6 !== void 0 ? ref6 : "GBP";
    var ref7;
    const currencySymbol = (ref7 = (ref2 = _libs_currencies__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z[currencyCode]) === null || ref2 === void 0 ? void 0 : ref2.symbol) !== null && ref7 !== void 0 ? ref7 : currencyCode;
    var ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        show: show,
        setShow: setShow,
        title: "".concat((discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.editIndex) !== undefined || (discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.editIndex) === 0 ? "Edit" : "Create", " Discount"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_7__/* .TextInput */ .o, {
                        validations: {
                            minLength: {
                                value: 1,
                                message: "Discount name must be at least 1 character"
                            },
                            maxLength: {
                                value: 70,
                                message: "Discount name must be at most 70 characters"
                            }
                        },
                        required: true,
                        label: "Discount Title",
                        placeholder: "Early Bird Discount",
                        value: (ref8 = discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.title) !== null && ref8 !== void 0 ? ref8 : "",
                        onChange: (data)=>{
                            setAmountTouched(true);
                            setDiscountModalData({
                                ...discountModalData,
                                title: data
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_7__/* .TextInput */ .o, {
                        required: true,
                        label: "Discount Quantity",
                        placeholder: "50",
                        type: "number",
                        value: (ref9 = discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.quantity) !== null && ref9 !== void 0 ? ref9 : 0,
                        validations: {
                            minLength: {
                                value: 1,
                                message: "Discounts available must be at least 1 "
                            },
                            maxLength: {
                                value: 4,
                                message: "Discounts available must be at most 9999"
                            }
                        },
                        onChange: (data)=>{
                            setDiscountModalData({
                                ...discountModalData,
                                quantity: data
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_ItemPicker__WEBPACK_IMPORTED_MODULE_6__/* .ItemPicker */ .H, {
                        itemClass: "!w-1/2",
                        choices: [
                            {
                                value: _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .DiscountType.Percentage */ .Lb.Percentage,
                                title: "Percentage"
                            },
                            {
                                value: _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .DiscountType.BuyOneGetOneFree */ .Lb.BuyOneGetOneFree,
                                title: "Buy 1 Get 1 Free"
                            },
                            {
                                value: _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .DiscountType.Amount */ .Lb.Amount,
                                title: "Amount"
                            }
                        ],
                        label: "Discount Type",
                        tooltip: "Discount Type",
                        onClick: (data)=>{
                            if (data === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .DiscountType.Amount */ .Lb.Amount) setAmountTouched(false);
                            setDiscountModalData({
                                ...discountModalData,
                                type: data
                            });
                        },
                        value: (ref10 = discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.type) !== null && ref10 !== void 0 ? ref10 : _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .DiscountType.Percentage */ .Lb.Percentage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_7__/* .TextInput */ .o, {
                        show: (discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.type) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .DiscountType.Percentage */ .Lb.Percentage,
                        type: "number",
                        required: true,
                        label: "Discount Percentage",
                        value: (ref11 = discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.percentage) !== null && ref11 !== void 0 ? ref11 : 0,
                        onChange: (data)=>{
                            setDiscountModalData({
                                ...discountModalData,
                                percentage: data
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_7__/* .TextInput */ .o, {
                        show: (discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.type) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .DiscountType.Amount */ .Lb.Amount,
                        type: "number",
                        required: true,
                        min: 0.01,
                        max: maximumAmount || undefined,
                        label: "Discount Amount (".concat(currencySymbol, ")"),
                        value: (ref12 = discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.amount) !== null && ref12 !== void 0 ? ref12 : "",
                        error: amountError,
                        onChange: (data)=>{
                            setDiscountModalData({
                                ...discountModalData,
                                amount: data
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_7__/* .TextInput */ .o, {
                        validations: {
                            minLength: {
                                value: 1,
                                message: "Discount codes must be at least 1 character"
                            },
                            maxLength: {
                                value: 70,
                                message: "Discount codes must be at most 70 characters"
                            }
                        },
                        required: true,
                        label: "Discount Code",
                        placeholder: "EARLYBIRD",
                        value: (ref13 = discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.code) !== null && ref13 !== void 0 ? ref13 : "",
                        onChange: (data)=>{
                            setDiscountModalData({
                                ...discountModalData,
                                code: data
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_ArrayTextInput__WEBPACK_IMPORTED_MODULE_3__/* .ArrayTextInput */ .M, {
                        label: "Applicable Tickets",
                        placeholder: "Day Pass",
                        options: (ref14 = (tickets !== null && tickets !== void 0 ? tickets : []).filter((t)=>t.ticketType === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .TicketType.Paid */ .zK.Paid || t.ticketType === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .TicketType.GroupGuest */ .zK.GroupGuest || t.ticketType === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .TicketType.InvoiceTicket */ .zK.InvoiceTicket).map((t)=>{
                            return {
                                id: t.title,
                                label: t === null || t === void 0 ? void 0 : t.title
                            };
                        })) !== null && ref14 !== void 0 ? ref14 : [],
                        value: discountModalData === null || discountModalData === void 0 ? void 0 : (ref3 = discountModalData.tickets) === null || ref3 === void 0 ? void 0 : ref3.map((t)=>({
                                key: t,
                                value: t
                            })),
                        onChange: (data)=>{
                            setDiscountModalData({
                                ...discountModalData,
                                tickets: data.map((t)=>t.value)
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "flex justify-between items-center w-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
                    className: "my-4 ml-auto",
                    title: "".concat((discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.editIndex) !== undefined || (discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.editIndex) === 0 ? "Edit Discount" : "Create Discount"),
                    type: "primary",
                    onClick: (e)=>{
                        var ref, ref1;
                        e.preventDefault();
                        var ref2;
                        if ((discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.type) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .DiscountType.Amount */ .Lb.Amount && (amount <= 0 || !/^\d+(\.\d{1,2})?$/.test(String((ref2 = discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.amount) !== null && ref2 !== void 0 ? ref2 : "")) || selectedTicketPrices.length > 0 && amount > maximumAmount)) {
                            setAmountTouched(true);
                            return;
                        }
                        var ref3, ref4, ref5, ref6, ref7;
                        const discountData = {
                            title: (ref3 = discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.title) !== null && ref3 !== void 0 ? ref3 : "Discount",
                            type: (ref4 = discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.type) !== null && ref4 !== void 0 ? ref4 : _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .DiscountType.Percentage */ .Lb.Percentage,
                            percentage: parseInt((ref5 = discountModalData === null || discountModalData === void 0 ? void 0 : (ref = discountModalData.percentage) === null || ref === void 0 ? void 0 : ref.toString()) !== null && ref5 !== void 0 ? ref5 : "0"),
                            amount: (discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.type) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .DiscountType.Amount */ .Lb.Amount ? Number(Number(discountModalData.amount).toFixed(2)) : undefined,
                            quantity: parseInt((ref6 = discountModalData === null || discountModalData === void 0 ? void 0 : (ref1 = discountModalData.quantity) === null || ref1 === void 0 ? void 0 : ref1.toString()) !== null && ref6 !== void 0 ? ref6 : "0"),
                            code: !!(discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.code) ? discountModalData.code : "NEWCODE",
                            tickets: (ref7 = discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.tickets) !== null && ref7 !== void 0 ? ref7 : []
                        };
                        var ref8;
                        const payload = [
                            ...(ref8 = formData === null || formData === void 0 ? void 0 : formData.discounts) !== null && ref8 !== void 0 ? ref8 : []
                        ];
                        if ((discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.editIndex) || (discountModalData === null || discountModalData === void 0 ? void 0 : discountModalData.editIndex) === 0) payload[discountModalData.editIndex] = discountData;
                        else payload.push(discountData);
                        setFormData({
                            ...formData,
                            discounts: payload
                        });
                        setShow(false);
                        setDiscountModalData(undefined);
                        setAmountTouched(false);
                    }
                })
            })
        ]
    });
}


/***/ })

}]);